import { render } from "./designSubForm.vue?vue&type=template&id=49d45651&scoped=true"
import script from "./designSubForm.vue?vue&type=script&lang=js"
export * from "./designSubForm.vue?vue&type=script&lang=js"

import "./designSubForm.vue?vue&type=style&index=0&id=49d45651&scoped=true&lang=scss"
import "./designSubForm.vue?vue&type=style&index=1&id=49d45651&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d45651"]])

export default __exports__